// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autoeval-banner {
  margin: 12px 16px;
  background: color-mix(in srgb, var(--ae-banner-secondary, #46528b) 88%, #0f172a);
  border-radius: 8px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid color-mix(in srgb, var(--ae-banner-secondary, #46528b) 55%, #fff);
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.autoeval-banner:hover {
  background: color-mix(in srgb, var(--ae-banner-secondary, #46528b) 75%, #fff);
}

.autoeval-banner__left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

.autoeval-banner__icon {
  font-size: 32px;
  flex-shrink: 0;
}

.autoeval-banner__text-wrap {
  min-width: 0;
}

.autoeval-banner__title {
  font-size: 14px;
  font-weight: 700;
  color: var(--ae-banner-text);
  margin: 0;
  line-height: 1.3;
  text-shadow: var(--ae-banner-text-shadow, none);
}

.autoeval-banner__msg {
  font-size: 12px;
  color: var(--ae-banner-text-muted);
  margin: 2px 0 0;
  line-height: 1.3;
}

.autoeval-banner__btn {
  flex-shrink: 0;
  background: var(--ae-banner-btn-bg);
  color: var(--ae-banner-btn-text);
  border: none;
  border-radius: 10px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s, opacity 0.2s;
}

.autoeval-banner__btn:hover {
  opacity: 0.92;
}
`, "",{"version":3,"sources":["webpack://./src/components/AutoevalBanner.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gFAAgF;EAChF,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mFAAmF;EACnF,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf","sourcesContent":[".autoeval-banner {\n  margin: 12px 16px;\n  background: color-mix(in srgb, var(--ae-banner-secondary, #46528b) 88%, #0f172a);\n  border-radius: 8px;\n  padding: 16px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  border: 1px solid color-mix(in srgb, var(--ae-banner-secondary, #46528b) 55%, #fff);\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.autoeval-banner:hover {\n  background: color-mix(in srgb, var(--ae-banner-secondary, #46528b) 75%, #fff);\n}\n\n.autoeval-banner__left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n}\n\n.autoeval-banner__icon {\n  font-size: 32px;\n  flex-shrink: 0;\n}\n\n.autoeval-banner__text-wrap {\n  min-width: 0;\n}\n\n.autoeval-banner__title {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--ae-banner-text);\n  margin: 0;\n  line-height: 1.3;\n  text-shadow: var(--ae-banner-text-shadow, none);\n}\n\n.autoeval-banner__msg {\n  font-size: 12px;\n  color: var(--ae-banner-text-muted);\n  margin: 2px 0 0;\n  line-height: 1.3;\n}\n\n.autoeval-banner__btn {\n  flex-shrink: 0;\n  background: var(--ae-banner-btn-bg);\n  color: var(--ae-banner-btn-text);\n  border: none;\n  border-radius: 10px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.2s, opacity 0.2s;\n}\n\n.autoeval-banner__btn:hover {\n  opacity: 0.92;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
